import React from 'react';
import { useParams, Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getFamilySegmentById } from '../config/familySegments';
import ComingSoon from '../shared/ComingSoon';

export default function FamilySegmentDetail() {
  const { segmentId } = useParams();
  const segment = getFamilySegmentById(segmentId);

  return (
    <div className="page">
      <Link to="/family-dashboard/segmentation-framework" className="back-link">
        <ArrowBackIcon fontSize="small" /> Back to Segmentation Framework
      </Link>
      {segment ? (
        <ComingSoon
          title={segment.title}
          description="This household segment's detail view is planned but not yet available. It will be built out in a future step."
        />
      ) : (
        <ComingSoon title="Unknown segment" description="This household segment does not exist." />
      )}
    </div>
  );
}
